import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import Rating from 'widgets/Rating/Rating';
import MultilineTrim from 'widgets/MultilineTrim/MultilineTrim';
import Icon from 'widgets/Icon/Icon';

export default class RecipeListItem extends PureComponent {
  static propTypes = {
    averageRating: PropTypes.number,
    cookingTime: PropTypes.number,
    id: PropTypes.number.isRequired,
    imageAlt: PropTypes.string,
    imageSrc: PropTypes.string,
    preparationTime: PropTypes.number,
    title: PropTypes.string.isRequired,
  };

  static defaultProps = {
    cookingTime: 0,
    preparationTime: 0,
  };

  renderFormattedTotalTime = () => {
    const { cookingTime, preparationTime } = this.props;

    const totalTime = cookingTime + preparationTime;

    if (totalTime === 0) {
      return null;
    }

    const mins = totalTime % 60;
    const hours = Math.floor(totalTime / 60);
    let duration = '';

    if (hours) {
      duration += `${hours} ${hours > 1 ? 'hrs' : 'hr'} `;
    }

    if (mins) {
      duration += `${mins} ${mins > 1 ? 'mins' : 'min'}`;
    }

    return (
      <>
        <Icon name="clock" />{duration}
      </>
    );
  };

  getRecipePath = () => {
    const { id, title } = this.props;
    return `/webshop/recipe/${title.replace(/[^a-zA-Z0-9]+/g, '-')}/${id}`;
  };

  render() {
    const {
      averageRating, imageSrc, imageAlt, title,
    } = this.props;

    return (
      <li className="bop-recipes__item">
        <Link className="gn-card gn-flat bop-recipes__link" to={this.getRecipePath()}>
          <div className="bop-recipes__image">
            <img src={imageSrc} alt={imageAlt} />
          </div>
          <div className="bop-recipes__heading">
            <MultilineTrim maxLines={2}>{title}</MultilineTrim>
          </div>
          <div className="bop-recipes__info">
            <div className="bop-recipes__totalTime">
              {this.renderFormattedTotalTime()}
            </div>
            {averageRating > 0 && (
              <div className="bop-recipes__rating">
                <Rating
                  withoutTitle
                  medium
                  reviewStats={{ averageRate: averageRating }}
                />
              </div>
            )}
          </div>
        </Link>
      </li>
    );
  }
}
